import { MarketAccordionItem } from '@market/react';
import { useTranslation } from 'react-i18next';
import styles from './FrequentlyAskedQuestions.module.css';

export interface FrequentlyAskedQuestionsProps {
  readonly frequentlyAskedQuestions: FrequentlyAskedQuestion[];
}

export interface FrequentlyAskedQuestion {
  readonly title: string;
  readonly content: string;
}

export const FrequentlyAskedQuestions = ({ frequentlyAskedQuestions }: FrequentlyAskedQuestionsProps) => {
  const { t } = useTranslation();

  return (
    <section className={styles.container} data-testid="frequently-asked-questions">
      <h2 className="heading-30">{t('bankingShared.frequentlyAskedQuestions')}</h2>
      <div className={styles.frequentlyAskedQuestions}>
        {frequentlyAskedQuestions.map((frequentlyAskedQuestion) => (
          <MarketAccordionItem key={frequentlyAskedQuestion.title} name={frequentlyAskedQuestion.title} size="medium">
            <span slot="label">{frequentlyAskedQuestion.title}</span>
            <p>{frequentlyAskedQuestion.content}</p>
          </MarketAccordionItem>
        ))}
      </div>
    </section>
  );
};
